module.exports = __webpack_public_path__ + "static/media/homilia-370-aparicion-virgen-coromoto.7742dab4.jpg";